import { AnyObject } from '@truvity/js-core__utils';
import { CredentialDto } from '@truvity/widget__jsonld';

export type AnyDid = string;

export type WalletDid = AnyDid;

export type EntityDid = AnyDid;

export type CredentialDid = AnyDid;

export type DraftNotFoundError = {
    code: 'ERRDRAFTNOTFOUND';
    draftId: CredentialDid;
};

export type DraftRevisionMissmatchError = {
    code: 'ERRDRAFTREVISIONMISSMATCH';
    draftId: CredentialDid;
};

export type CredentialNotFoundError = {
    code: 'ERRCREDENTIALNOTFOUND';
    credentialId: CredentialDid;
};

export type CredentialNotSupportedError = {
    code: 'ERRCREDENTIALNOTSUPPORTED';
    credentialId: CredentialDid;
};

export type NoAccessError = {
    code: 'ERRNOACCESS';
};

export type UnknownError = {
    code: 'ERRUNKNOWN';
};

export type WidgetNetworkErrors = NoAccessError | UnknownError;

export type ViewWidgetErrors = CredentialNotFoundError | CredentialNotSupportedError | WidgetNetworkErrors;

export type EditWidgetErrors =
    | DraftNotFoundError
    | DraftRevisionMissmatchError
    | CredentialNotFoundError
    | CredentialNotSupportedError
    | WidgetNetworkErrors;

export type VcPreview = {
    Preview: string;
    VcDid: CredentialDid;
};

type CredentialPayload = CredentialDto & {
    revision: number;
};

export type WidgetViewApi = {
    getCredentialSchema: (
        credentialId: CredentialDid,
        walletDid: WalletDid,
        entityDid: EntityDid,
    ) => Promise<AnyObject>;

    getCredential: (
        credentialId: CredentialDid,
        walletDid: WalletDid,
        entityDid: EntityDid,
    ) => Promise<CredentialPayload>;
};

type CredentialUpdatePayload = {
    claims: AnyObject;
    revision: number;
};

export type WidgetEditApi = WidgetViewApi & {
    updateCredential: (
        draftId: CredentialDid,
        walletDid: WalletDid,
        entityDid: EntityDid,
        payload: CredentialUpdatePayload,
    ) => Promise<unknown>;
};

export type WalletViewApi = {
    getPresignedDownloadUrlV1: (
        url: string,
        walletDid: WalletDid,
        entityDid: EntityDid,
    ) => Promise<{
        DownloadUrl: string;
    }>;
};

export type WalletEditApi = WalletViewApi & {
    getPresignedUploadUrlV1: (
        walletDid: WalletDid,
        entityDid: EntityDid,
    ) => Promise<{
        FileDid: AnyDid;
        UploadURL: string;
    }>;

    finalizeUploadV1: (fileDid: AnyDid, walletDid: WalletDid, entityDid: EntityDid) => Promise<void>;
};
